<div class="row align-items-center mb-3" *ngIf="statusCode == 0">
    <div class="col-auto">
        <h4 class="section-title mb-0">{{ "HOME.LATEST-VIDEOS" | translate }}</h4>
    </div>
    <div class="col-auto ml-auto">
        <div class="see-more">
            <a [routerLink]="['/videos']"
                >{{ "GENERAL.VIEW-MORE" | translate }} <fa-icon [icon]="icons.arrowRight"></fa-icon
            ></a>
        </div>
    </div>
</div>

<div *ngIf="statusCode == 0" class="row">
    <div class="col-lg-4 mb-4" *ngFor="let news of registers">
        <div class="video-card">
            <img class="video-image" [src]="news.videos[0].url_capa" [alt]="news.title" />
            <h3 class="video-title">
                {{ news.title }}
            </h3>
            <a class="video-link" [href]="news.videos[0].url_video" target="_blank" rel="noopener noreferrer"></a>
        </div>
    </div>
</div>
